// This file is generated by pnpm icons:generate. Do not edit.

import {createSinglePathSVG} from './TEMPLATE'

export const Pause_Filled_Corner0_Rounded = createSinglePathSVG({
  path: 'M20.25 4.5v15a1.5 1.5 0 0 1-1.5 1.5H15a1.5 1.5 0 0 1-1.5-1.5v-15A1.5 1.5 0 0 1 15 3h3.75a1.5 1.5 0 0 1 1.5 1.5ZM9 3H5.25a1.5 1.5 0 0 0-1.5 1.5v15a1.5 1.5 0 0 0 1.5 1.5H9a1.5 1.5 0 0 0 1.5-1.5v-15A1.5 1.5 0 0 0 9 3Z',
  viewBox: '0 0 24 24',
  glyph: 'Pause_Filled_Corner0_Rounded',
})

export const Pause_Filled_Corner2_Rounded = createSinglePathSVG({
  path: 'M20.25 4.5v15a1.5 1.5 0 0 1-1.5 1.5H15a1.5 1.5 0 0 1-1.5-1.5v-15A1.5 1.5 0 0 1 15 3h3.75a1.5 1.5 0 0 1 1.5 1.5ZM9 3H5.25a1.5 1.5 0 0 0-1.5 1.5v15a1.5 1.5 0 0 0 1.5 1.5H9a1.5 1.5 0 0 0 1.5-1.5v-15A1.5 1.5 0 0 0 9 3Z',
  viewBox: '0 0 24 24',
  glyph: 'Pause_Filled_Corner2_Rounded',
})

export const Pause_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'M18.75 3H15a1.5 1.5 0 0 0-1.5 1.5v15A1.5 1.5 0 0 0 15 21h3.75a1.5 1.5 0 0 0 1.5-1.5v-15a1.5 1.5 0 0 0-1.5-1.5Zm0 16.5H15v-15h3.75ZM9 3H5.25a1.5 1.5 0 0 0-1.5 1.5v15a1.5 1.5 0 0 0 1.5 1.5H9a1.5 1.5 0 0 0 1.5-1.5v-15A1.5 1.5 0 0 0 9 3Zm0 16.5H5.25v-15H9Z',
  viewBox: '0 0 24 24',
  glyph: 'Pause_Stroke2_Corner0_Rounded',
})

export const Pause_Stroke2_Corner2_Rounded = createSinglePathSVG({
  path: 'M18.75 3H15a1.5 1.5 0 0 0-1.5 1.5v15A1.5 1.5 0 0 0 15 21h3.75a1.5 1.5 0 0 0 1.5-1.5v-15a1.5 1.5 0 0 0-1.5-1.5Zm0 16.5H15v-15h3.75ZM9 3H5.25a1.5 1.5 0 0 0-1.5 1.5v15a1.5 1.5 0 0 0 1.5 1.5H9a1.5 1.5 0 0 0 1.5-1.5v-15A1.5 1.5 0 0 0 9 3Zm0 16.5H5.25v-15H9Z',
  viewBox: '0 0 24 24',
  glyph: 'Pause_Stroke2_Corner2_Rounded',
})
